import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import { getCaseHeader, getHistory, updateCaseHeader } from "actions/homeowner/caseforms";
import CaseProfileDetail from "../../../components/Homeowner/CaseDetails/CaseProfileDetail";
import { MSpinner } from "components/Shared";
class CaseProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      controlNumber: null
    };
    this.loadDataForControlNumber = this.loadDataForControlNumber.bind(this);
    this.currentControlNumber = this.currentControlNumber.bind(this);
  }
  componentDidMount() {
    const controlNumber = this.currentControlNumber();
    if (controlNumber && controlNumber !== this.state.controlNumber) {
      this.loadDataForControlNumber(controlNumber);
    }
  }
  componentDidUpdate() {
    // Figure out if the location or the props changed and load data accordingly
    const controlNumber = this.currentControlNumber();
    if (controlNumber !== this.state.controlNumber) {
      this.loadDataForControlNumber(controlNumber);
    }
  }
  loadDataForControlNumber(controlNumber) {
    this.props.getCaseHeader(controlNumber);
    this.props.getHistory(controlNumber);
    this.setState({ controlNumber: controlNumber });
  }
  currentControlNumber() {
    const { controlNumber, location } = this.props;
    const locationControlNumber = (location && location.state && location.state.controlNumber);
    return controlNumber || locationControlNumber;
  }
  render() {
    if (this.props.fetchingHistory || this.props.fetchingHeader || !this.state.controlNumber) {
      return <MSpinner />;
    }
    return (
      <CaseProfileDetail
        {... this.props}
        controlNumber={this.state.controlNumber}
        fetchingHeader={this.props.fetchingHeader}
        caseHeader={this.props.caseHeader}
        caseHistory={this.props.caseHistory}
        updatingCaseHeader={this.props.updatingCaseHeader}
        updateCaseHeader={this.props.updateCaseHeader}
        getCaseHeader={this.props.getCaseHeader}
        verticalDisplay={this.props.verticalDisplay}
      />
    );
  }
}
CaseProfile.propTypes = {
  controlNumber: PropTypes.number,
  fetchingHeader: PropTypes.bool.isRequired,
  caseHeader: PropTypes.object.isRequired,
  getCaseHeader: PropTypes.func.isRequired,
  caseHistory: PropTypes.object.isRequired,
  getHistory: PropTypes.func.isRequired,
  fetchingHistory: PropTypes.bool.isRequired,
  history: PropTypes.object,
  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  location: PropTypes.object,
  verticalDisplay: PropTypes.bool,
};
const mapStateToProps = state => {
  return {
    fetchingHeader: state.caseForms.fetchingHeader,
    caseHeader: state.caseForms.caseHeader,
    caseHistory: state.caseForms.caseHistory,
    fetchingHistory: state.caseForms.fetchingHistory,
    updatingCaseHeader: state.caseForms.updatingCaseHeader
  };
};
const mapDispatchToProps = dispatch => ({
  getCaseHeader(controlNumber) {
    dispatch(getCaseHeader(controlNumber));
  },
  getHistory(controlNumber) {
    dispatch(getHistory(controlNumber));
  },
  updateCaseHeader(controlNumber, dto) {
    dispatch(updateCaseHeader(controlNumber, dto));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CaseProfile));
